var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 84,
    viewBox: "0 0 81 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 80H8C3.56 80 0 76.4 0 72L0.04 16C0.04 11.6 3.56 8 8 8H12V0H20V8H52V0H60V8H64C68.4 8 72 11.6 72 16V40H64V32H8V72H36V80ZM76.52 59.96L79.36 57.12C80.92 55.56 80.92 53.04 79.36 51.48L76.52 48.64C74.96 47.08 72.44 47.08 70.88 48.64L68.04 51.48L76.52 59.96ZM73.68 62.8L52.48 84H44V75.52L65.2 54.32L73.68 62.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.8763ae33c3150640ac900d1c20aba074.svg";
export { ForwardRef as ReactComponent };